import { parsePhoneNumberFromString } from 'libphonenumber-js';

// перевіряє чи є номер телефону валідним
export function isValidPhone(phone) {
  const phoneNumber = parsePhoneNumberFromString(phone);
  return phoneNumber ? phoneNumber.isValid() : false;
}
